(function ($) {
  $(document).ready(function () {
    // $("#databaseTable").DataTable({
    //   "pageLength": 20,
    //   // bPaginate: false,
    //   bFilter: false,
    //   bInfo: false,
    //   "language": {
    //     "sLengthMenu": "Pokaż _MENU_ wyników na stronę",
    //     "paginate": {
    //       "previous": '<span class="icon-arrow-long-button"></span>',
    //       "next": '<span class="icon-arrow-long-button"></span>',
    //     },
    //   },
    // });

    // school pagination db

    $("#pp_prev_page").on("click", function () {
      var existinVAlue = $(".with_paginations input[name=pp]").val();
      $(".with_paginations input[name=pp]").val(existinVAlue - 1);
      $("#mainDBform").submit();
    });

    $("#pp_next_page").on("click", function () {
      var existinVAlue = $(".with_paginations input[name=pp]").val();
      $(".with_paginations input[name=pp]").val(+existinVAlue + 1);
      $("#mainDBform").submit();
    });
  });
})(jQuery);
